import { waitDOMContentLoaded } from '@/helpers/DOM'
import '@lottiefiles/lottie-player'

let loadingCount = 1

function getBoxLoading() {
    for (let i = 0; i < document.body.children.length; i++) {
        if (document.body.children[i].classList.contains('box-loading')) {
            return document.body.children[i]
        }
    }

    return null
}

export function startLoading(spinner = false) {
    return new Promise(async (resolve) => {
        await waitDOMContentLoaded()

        if (loadingCount === 0) {
            document.body.classList.add('loading')
        }

        if (spinner && !getBoxLoading()) {
            let boxLoading = document.createElement('div')
            boxLoading.className = 'box-loading'

            let player = document.createElement('lottie-player')
            player.src = 'images/loading-rocket.json'
            player.className = 'vh-100'
            player.setAttribute('speed', '1')
            player.setAttribute('loop', 'true')
            player.setAttribute('autoplay', 'true')

            boxLoading.append(player)
            document.body.append(boxLoading)
        }

        loadingCount++

        resolve()
    })
}

export async function doneLoading() {
    await waitDOMContentLoaded()

    loadingCount = loadingCount > 0 ? loadingCount - 1 : 0

    if (loadingCount === 0) {
        document.body.classList.remove('loading')
        getBoxLoading()?.remove()
    }
}
